// src/features/infoscreens/services/infoscreens.js
import { apiClient } from '../../../services/api/client';

export const infoscreensAPI = {
  // Create infoscreen
  createInfoscreen: (data) => 
    apiClient.post('/api/v1/infoscreens/infoscreens/', data),
  
  // Get infoscreen by ID
  getInfoscreenById: (infoscreenId) => 
    apiClient.get(`/api/v1/infoscreens/infoscreens/${infoscreenId}`),
  
  // List infoscreens (by department - from token)
  listInfoscreens: () => 
    apiClient.get('/api/v1/infoscreens/infoscreens/'),
  
  // Update infoscreen
  updateInfoscreen: (infoscreenId, data) => 
    apiClient.put(`/api/v1/infoscreens/infoscreens/${infoscreenId}`, data),
  
  // Delete infoscreen
  deleteInfoscreen: (infoscreenId) => 
    apiClient.delete(`/api/v1/infoscreens/infoscreens/${infoscreenId}`),
  
  // Assign room to infoscreen
  assignRoom: (infoscreenId, data) => 
    apiClient.post(`/api/v1/infoscreens/infoscreens/${infoscreenId}/rooms`, data),
  
  // Unassign room from infoscreen
  unassignRoom: (infoscreenId, roomId) => 
    apiClient.delete(`/api/v1/infoscreens/infoscreens/${infoscreenId}/rooms/${roomId}`),
  
  // Check infoscreen (no authentication required)
  checkInfoscreen: (data) => 
    apiClient.post('/api/v1/infoscreens/infoscreens/check', data),
  
  // Get infoscreen status (no authentication required)
  getInfoscreenStatus: (infoscreenId, loginCode) => 
    apiClient.get('/api/v1/infoscreens/infoscreens/status', {
      params: { infoscreen_id: infoscreenId, login_code: loginCode }
    }),
};